import { Auth } from 'aws-amplify';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate, useNavigate } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';

const LoginSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const handleClick = () => {
    if (authStatus != 'authenticated'){
      navigate('/public/auth')
    }
  }

  return (
    <Box marginLeft={theme.spacing(2)}>
      <Button  onClick = {handleClick} sx={{ display: { xs: 'none', sm: 'block' }, textTransform: 'none' }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LoginIcon sx={{ color: 'primary.main' }} />
          <Typography variant = 'h3'sx={{ color: 'primary.main' }}><b>Login</b></Typography>
        </Stack>
      </Button>

    </Box>
  );
};

export default LoginSection;
